import { api } from '../lib/api.js';
import type { SearchResult } from '@attendance/shared';

export type { SearchEntityType, SearchGroup, SearchHit, SearchResult } from '@attendance/shared';

/**
 * Global cross-entity search — the client for `GET /api/search`, used by the
 * ⌘K command palette to find PEOPLE and RECORDS, not just pages.
 *
 * The server owns everything that matters here: which entity groups the
 * caller's role and the tenant's feature flags allow, the row-level scope
 * (a manager sees their own team only), the minimum query length, and the
 * caps. This client deliberately adds no filtering of its own — anything it
 * hid would just be a second, divergent copy of a rule that already exists
 * server-side.
 *
 * `q` shorter than SEARCH_MIN_QUERY_LENGTH is a 422, not an empty result, so
 * callers must not fire below it (the palette gates on the same constant).
 */
export const searchApi = {
  global: (q: string, signal?: AbortSignal): Promise<SearchResult> =>
    api
      .get<{ data: SearchResult }>(`/search?q=${encodeURIComponent(q)}`, { signal })
      .then((r) => r.data),
};
